import { FadeIn } from "@/components/Reveal";
import ChapterHeader from "@/components/ChapterHeader";
import UploadedPhotos from "@/components/UploadedPhotos";
import { useCategoryPhotos, pickPhoto } from "@/lib/usePhotos";

const OUTDOOR = [
  { title: "1942 Willys Jeep", desc: "Original World War II left-hand drive open-top petrol jeeps — still running, still yours to ride." },
  { title: "All-Terrain Vehicles", desc: "Adventure rides through the orchard trails and forest paths." },
  { title: "Bicycles", desc: "Cycles for a slow morning under the mango canopy." },
];

const INDOOR = ["Billiards", "Snooker", "Table Tennis", "Carrom", "Darts", "Library"];

export default function Activities() {
  const activityPhotos = useCategoryPhotos("activity");
  const outdoor = OUTDOOR.map((a, i) => ({ ...a, img: pickPhoto(activityPhotos, i) }));
  const indoorImg = pickPhoto(activityPhotos, OUTDOOR.length);
  return (
    <main data-testid="activities-page" className="pt-32 pb-24">
      <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeIn>
          <div className="stamp mb-8">Vol · IV · Experiences</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#F2E7D0] max-w-5xl">
            Ride a <em className="italic text-[#D97645]">1942</em>. Then rack the balls.
          </h1>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-24">
        <ChapterHeader num="01" kicker="Outdoors" title="The fleet & the trail." />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {outdoor.map((a, i) => (
            <FadeIn delay={i * 0.1} key={a.title}>
              <div data-testid={`activity-${a.title.replace(/\s+/g,'-').toLowerCase()}`} className="group">
                <div className="overflow-hidden aspect-[4/5] bg-[#27221C]">
                  {a.img && <img src={a.img} alt={a.title} className="w-full h-full object-cover vintage-img group-hover:scale-[1.03] transition-transform duration-700" />}
                </div>
                <div className="chapter-num mt-6">Experience · {String(i+1).padStart(2, "0")}</div>
                <h3 className="mt-2 font-display text-3xl text-[#F2E7D0]">{a.title}</h3>
                <p className="mt-2 text-sm text-[#B8A891]">{a.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <section className="bg-[#27221C] py-24">
        <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
          <ChapterHeader num="02" kicker="Indoors" title="Games, and shelves of books going back several decades." />
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-7 grid grid-cols-2 gap-4">
              {INDOOR.map((it, i) => (
                <FadeIn delay={i * 0.05} key={it}>
                  <div className="border border-white/10 p-6">
                    <div className="chapter-num">Room · {String(i+1).padStart(2,"0")}</div>
                    <div className="font-display text-3xl mt-2 text-[#F2E7D0]">{it}</div>
                  </div>
                </FadeIn>
              ))}
            </div>
            <FadeIn delay={0.15} className="md:col-span-5">
              <div className="w-full aspect-[3/4] bg-[#27221C] overflow-hidden">
                {indoorImg && <img src={indoorImg} alt="Billiards" className="w-full h-full object-cover vintage-img" />}
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      <UploadedPhotos category="activity" kicker="In Motion" title="The fleet, the trail, the room after dark." />
    </main>
  );
}
